/**
 * @author Milton Filho
 */
import { AxiosError } from 'axios';

interface ApiErrorBody {
  message?: string;
  error?: string;
}

/**
 * Extract the human-readable error message that the API returned in the
 * response body. The backend consistently serializes errors as
 * `{ error: string, message: string }`, so we prefer `message` first and
 * fall back to `error`.
 *
 * Returns undefined when the response has no body-provided message — the
 * caller is responsible for choosing the appropriate fallback (e.g. a
 * component-specific copy, or the generic Axios wrapper message).
 */
export const extractApiErrorMessage = (err: AxiosError): string | undefined => {
  const data = err?.response?.data as ApiErrorBody | undefined;
  return data?.message || data?.error || undefined;
};
